<span (click)="backClicked()" matTooltip="Tilbake"
  style="display: flex; align-items: center; justify-content: center; padding-left: 24px; padding-right: 24px; height: 100%; cursor: pointer;">
  <mat-icon>arrow_back</mat-icon>
</span>